import { Component, OnInit } from '@angular/core';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { ActivatedRoute } from '../../../node_modules/@angular/router';
import { BsDatepickerConfig } from '../../../node_modules/ngx-bootstrap/datepicker/public_api';

@Component({
  selector: 'app-event-log-list',
  templateUrl: './event-log-list.component.html',
  styleUrls: ['./event-log-list.component.css']
})
export class EventLogListComponent extends BaseListCtl {

  datePickerConfig : Partial<BsDatepickerConfig>;

  constructor(public locator: ServiceLocatorService, public router: ActivatedRoute) {
    super(locator.endpoints.EVENTACCESSLOG,locator, router);

    this.datePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: true,
        
        maxDate: new Date(),
        dateInputFormat: 'YYYY/MM/DD'
      });
   }

   populateForm(form, data) {
    form.id = data.id;
    form.unitId=data.unitId;
    form.unitName=data.unitName;
    form.eventId=data.eventId;
    form.eventName=data.eventName;
    form.dateTime=data.dateTime;
    form.date=data.date;
    form.endTime = data.endTime;
    form.userId=data.userId;
    form.userName=data.userName;
    form.latPos=data.latPos;
    form.lonPos=data.lonPos;
    form.imei=data.imei;
    form.accessType=data.accessType;
    form.userStatus = data.userStatus;
    console.log('----->',data);
  }

}
